/**
 * Flix legal entity an invoice is booked against.
 *
 * Fixed enum — the value stored is the canonical legal-entity name itself
 * (no separate key/label split, since these names are already the labels the
 * business uses). `null` = not yet assigned. Mirrors the PO-column singleSelect
 * pattern used elsewhere in the Database table.
 */
export type InvoiceEntity =
  | 'Flix SE'
  | 'FlixTrain SE'
  | 'FlixTrain GmbH'
  | 'FlixMobility Experience GmbH'
  | 'FlixMobility Tech GmbH'
  | 'FlixBus DACH GmbH'

export const INVOICE_ENTITIES: InvoiceEntity[] = [
  'Flix SE',
  'FlixTrain SE',
  'FlixTrain GmbH',
  'FlixMobility Experience GmbH',
  'FlixMobility Tech GmbH',
  'FlixBus DACH GmbH',
]

/** singleSelect options for the DataGrid (incl. an "Unassigned" / null choice). */
export const ENTITY_OPTIONS: { value: InvoiceEntity | null; label: string }[] = [
  { value: null, label: 'Unassigned' },
  ...INVOICE_ENTITIES.map((value) => ({ value, label: value })),
]

/** Coalesce an unknown/legacy entity value to a valid entity, or null. */
export function normalizeEntity(value: string | null | undefined): InvoiceEntity | null {
  return INVOICE_ENTITIES.includes(value as InvoiceEntity) ? (value as InvoiceEntity) : null
}
